export const integrationItem = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  p: 2,
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  width: '220px',
  backgroundColor: '#fafafa',
};

export const connectButton = {
  mt: 2,
  width: '100%',
};

export const organizationCalendarStatus = {
  mt: 2,
  px: 2,
  py: 1,
  color: 'white',
  borderRadius: '4px',
  fontWeight: 600,
  textAlign: 'center',
};
